export default __webpack_public_path__ + "static/media/gallery_01.c3461317.jpg";